import { cloneDeep } from 'lodash';
import { parseString } from 'xml2js';

const state = () => {
    return {
        initializing: false,
        initialized: false,
        contentAssistEnabled: false,
        bundles: {}
    };
};

const getters = {
    // return getters as functions to prevent caching at the getter level
    // calling code must invoke $store.getters.getXXX();
    // each getter performs a clone on object responses in order to keep the store
    // state clean (ie. nothing outside the store can inadvertently or directly change
    // the state)

    getBundle: state => (bundleName => cloneDeep(state.bundles[bundleName])),
    getContent: state => (bundleName, itemKey) => {
        let content = '';
        if (state.bundles[bundleName] && state.bundles[bundleName][itemKey]) {
            const bundle = cloneDeep(state.bundles[bundleName]);
            content = bundle[itemKey];
        }
        return content;
    }
};

const mutations = {
    bundle: (state, { bundleName, bundle }) => {
        state.bundles[bundleName] = bundle;
    },
    initializing: (state, initializing) => {
        state.initializing = initializing;
    },
    initialized: (state, initialized) => {
        state.initialized = initialized;
    },
    contentAssistEnabled: (state, enabled) => {
        state.contentAssistEnabled = enabled;
    }
};

const actions = {

    initializeContent: ({ state, commit }) => {
        if (!state.initialized && !state.initializing) {
            commit('initializing', true);
            window.document.addEventListener('keypress', (event) => {
                // If Shift + ~ is pressed
                // Toggle content assist
                if (event.keyCode == 126) {
                    commit('contentAssistEnabled', !state.contentAssistEnabled);
                }
            });
            const promises = [];

            // Pull standard inline content
            document.querySelectorAll('[data-script-type="inline-content"]').forEach((contentScript) => {
                const xmlString = contentScript.innerText;
                const bundleName = contentScript.getAttribute('data-content-bundle');
                promises.push(new Promise((resolve) => {
                    parseString(xmlString, (err, content) => {
                        const bundle = {};
                        if (content && content.items && content.items.item) {
                            content.items.item.forEach((item) => {
                                bundle[item.$.id] = item.content[0];
                            });
                        }
                        commit('bundle', { bundleName, bundle });
                        resolve();
                    });
                }));
            });

            // Pull inline content for non-secure landing content
            document.querySelectorAll('[data-script-type="nonsecure-inline-content"]').forEach((contentScript) => {
                const xmlString = contentScript.innerText;
                const bundleName = contentScript.getAttribute('data-content-bundle');
                promises.push(new Promise((resolve) => {
                    parseString(xmlString, (err, content) => {
                        const bundle = {};
                        if (content && content.items && content.items.item) {
                            content.items.item.forEach((item) => {
                                let nonsecureContent = {};

                                // required fields
                                nonsecureContent.internal = ("true" == item.internal[0]) ? true : false;
                                nonsecureContent.order = item.order[0];
                                nonsecureContent.contentName = item.pageContentName[0];

                                // optional by type
                                nonsecureContent.linkText
                                    = (typeof item.linkText !== 'undefined') ? item.linkText[0] : '';
                                nonsecureContent.url = (typeof item.url !== 'undefined') ? item.url[0] : '';
                                nonsecureContent.blurb = (typeof item.blurb !== 'undefined') ? item.blurb[0] : '';
                                nonsecureContent.articleBlurb
                                    = (typeof item.articleBlurb !== 'undefined') ? item.articleBlurb[0] : '';

                                bundle[item.$.id] = nonsecureContent;
                            });
                        }
                        commit('bundle', { bundleName, bundle });
                        resolve();
                    });
                }));
            });

            Promise.all(promises).then(() => {
                commit('initializing', false);
                commit('initialized', true);
            });
        }
    }

};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
